<template>
    <div class="dark font-weight-600 d-flex" v-if="showExport && !getIsExportingAgents">
        <span class="pointer mr-3 relative" @click="showingExportOptions = !showingExportOptions">
            <i class="ico ico-export fs-large"></i>
            <span>Export</span>

            <ul class="floating-menu bottom centered" v-if="showingExportOptions">
                <li v-for="exportOption in exportOptions" :key="exportOption.label">
                    <span class="pointer" @click.stop="handleExport(exportOption.action)">
                        {{ exportOption.label }}
                    </span>
                </li>
            </ul>
        </span>
    </div>
    <div class="mr-3" v-else>
        <loader size="small"></loader>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/tools/loaders/loader1'

export default {
    data() {
        return {
            showingExportOptions: false
        }
    },
    props: {
        exportOptions: {
            type: Array
        },
    },
    computed: {
        ...mapGetters([
            'getIsExportingAgents'
        ]),
        showExport() {
            // Hide to restricted users
            return !this.accessPermissionFilter(['restricted']);
        }
    },
    methods: {
        handleExport(action) {
            action();
            this.showingExportOptions = false;
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss">
    @import '../assets/scss/_variables.scss';

    ul.floating-menu li {
        display: block;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// ExportV2.vue?3e08dbc6